import { CheckboxV2 } from '@agro-club/agroclub-shared'
import { isUS } from 'env'
import { FormikFieldsType } from 'modules/domain/types'
import { endpoints } from 'modules/endpoints'
import { useTranslation } from 'react-i18next'
import FormSelectShared from 'views/components/FormSelectShared'
import { MarginWrapper } from 'views/pages/LogisticsKR/components/AddDraftTripModal/styled'

interface Props {
  formik: FormikFieldsType
  disabled?: boolean
  product_id?: string
  showMatchingCheckBox?: boolean
}

export const SeasonSelect = ({ formik, disabled, product_id, showMatchingCheckBox }: Props) => {
  const { t } = useTranslation('bid')
  const selectJSX = (
    <FormSelectShared
      formik={formik}
      label={isUS ? t('form.cropYear') : t('form.season')}
      placeholder={t('form.seasonPlaceholder')}
      fieldName="season"
      endpoint={endpoints.seasonsList(formik.values.product || product_id)}
      disabled={disabled}
      showSearch={false}
    />
  )

  return (
    <div>
      {selectJSX}
      {showMatchingCheckBox && (
        <MarginWrapper>
          <CheckboxV2
            id="use_season_in_matching"
            checked={formik.values.use_season_in_matching}
            onChange={() => formik.setFieldValue('use_season_in_matching', !formik.values.use_season_in_matching)}
            label={t('seasonInMatching.labelFull')}
            disabled={!formik.values.season}
          />
        </MarginWrapper>
      )}
    </div>
  )
}
